import React, { useState } from "react";
import useStyles from "./styles";
import OPEN_PLAY_COMMUNITY_DATA from "./data";
import OpenPlayCommunityPopup from "./OpenPlayCommunityPopup";

const OPEN_PLAY_LOGO =
  "https://km-landing.s3.ap-south-1.amazonaws.com/Images/open-play-wtsp-comm.png";

const WHATSAPP_ICON =
  "https://km-landing.s3.ap-south-1.amazonaws.com/Images/wtsp-comm-icon.png";

export default function OpenPlayCommunity() {
  const classes = useStyles();

  const [selectedCity, setSelectedCity] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);

  const handleCityClick = (city) => {
    setSelectedCity(city);
    setPopupOpen(true);
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
    setSelectedCity(null);
  };

  return (
    <>
      <div className={classes.communityContainer}>
        {/* Header */}
        <div className={classes.communityHeader}>
          <img
            src={OPEN_PLAY_LOGO}
            alt="OpenPlay Community"
            className={classes.communityLogo}
          />

          <h2 className={classes.communityHeading}>
            Join Our Open Play Community
          </h2>
        </div>

        {/* Description */}
        <div className={classes.communityDescription}>
          <p className={classes.descriptionText}>
            Where players become an insider circle.{" "}
            <span className={classes.descriptionHighlight}>
              10,000+ Members | 300+ Weekly Games Hosted
            </span>
          </p>
        </div>

        {/* City heading */}
        <h3 className={classes.chooseCityText}>Choose your City</h3>

        {/* City horizontal scroll */}
        <div className={classes.cityScrollContainer}>
          {OPEN_PLAY_COMMUNITY_DATA.map((city) => (
            <div
              key={city.city}
              className={classes.cityCard}
              onClick={() => handleCityClick(city)}
            >
              <div className={classes.cityImageWrapper}>
                {city.image ? (
                  <img
                    src={city.image}
                    alt={`${city.city} Open Play Community`}
                    className={classes.cityImage}
                  />
                ) : (
                  <div className={classes.blankCityImage} />
                )}

                <img
                  src={WHATSAPP_ICON}
                  alt="WhatsApp"
                  className={classes.whatsappIcon}
                />
              </div>

              <div className={classes.cityName}>{city.city}</div>
            </div>
          ))}
        </div>
      </div>

      <OpenPlayCommunityPopup
        open={popupOpen}
        city={selectedCity}
        onClose={handleClosePopup}
      />
    </>
  );
}
